import React from "react";

import cv from "../assets/cv.pdf";

const Navbar = () => {
  return (
    <div className='z-50 bg-dark-500 w-full top-0 left-0 px-8 py-4 lg:px-20 xl:px-36'>
      <div className='flex justify-between items-center text-white'>
        <ul className='hidden md:flex'>
          <li className='p-4'>
            <a href='#home' className='hover:underline'>
              About
            </a>
          </li>
          <li className='p-4'>
            <a href='#education' className='hover:underline'>
              Education
            </a>
          </li>
          <li className='p-4'>
            <a href='#experience' className='hover:underline'>
              Experience
            </a>
          </li>
          <li className='p-4'>
            <a href='#skills' className='hover:underline'>
              Skills
            </a>
          </li>
          <li className='p-4'>
            <a href='#publications' className='hover:underline'>
              Publications
            </a>
          </li>
          <li className='p-4'>
            <a href='#projects' className='hover:underline'>
              Projects
            </a>
          </li>
          <li className='p-4'>
            <a href='#certs' className='hover:underline'>
              Certfications
            </a>
          </li>
        </ul>
        <a
          href={cv}
          rel='noreferrer'
          target='_blank'
          className=' bg-teal-500 rounded-full px-4 py-1 border border-teal-800 border border-4'
        >
          Resume
        </a>
      </div>
    </div>
  );
};

export default Navbar;
